import SigliveServiceV3 from 'Service/sigliveServiceV3';

const getReportBrand = async (queries) => {
  const { data } = await SigliveServiceV3({ method: 'GET', url: `/reporting/summary-brand?${queries}` });

  return data?.data;
};

export default getReportBrand;
